<template>
  <div
    class="row"
  >
    <LoadingBar ref="LoadingBar">
    </LoadingBar>
    <Main/>
  </div>
</template>

<script>
import LoadingBar from '@/components/LoadingBar'
import Main from '@/components/typhoon_tw/Main'
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'

export default {
  components: {
    'LoadingBar': LoadingBar,
    'Main': Main,
  },

  methods: {

  },

  computed: {
    ...mapGetters({
      get_loading_state: types.GET_LOADING_STATE
    })
  },

  watch: {
    get_loading_state() {
      let loading = this.get_loading_state
      if (loading) {
        this.$refs.LoadingBar.punch(loading);
      }
      else {
        this.$refs.LoadingBar.done();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/typhoon_tw/TyphoonTW.vue